import { TicketPurchaseFormArgsType } from "./type";
import useTicketPurchaseFormService from "./service";
import TicketPurchaseInfoText from "../ticketPurchaseInfoText";
import Button from "../../../../../../shared/components/button";
import ButtonType from "../../../../../../shared/enums/ButtonTypes";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import DynamicFormRenderer from "../../../../../../shared/form/renderer";
import { useRegDetail } from "shared/context/regDetail";
import { useParticipantDetails } from "../../../../context/participantDetails";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function TicketPurchaseRegForm(props: TicketPurchaseFormArgsType) {
  const copies = useCopies();
  const { currencyCode, id } = useRegDetail();
  const { participantDetails } = useParticipantDetails();
  const service = useTicketPurchaseFormService(props);

  return (
    <div className="buyTicket_wrapper">
      <TicketPurchaseInfoText
        backClickHandler={props.backClickHandler}
        state={props.state}
        openAssignTicketToSelfHandler={props.openAssignTicketToSelfHandler}
      />
      <div className="buyInventory_cardWrapper">
        <div className="buyTicket_formGroup--form">
          <DynamicFormRenderer
            disabled={service.isFormDisabled}
            key={props.state.participantData?.uiVersion}
            formRef={service.formRef}
            schemaList={props.state.participantData?.profile || []}
            parseValuesOnSubmitToApiReq={true}
            formSubmitHandler={service.submitHandler}
            customData={{
              organizationId: props.state.participantData?.organizationId,
              currencyCode,
              registrationId: id,
              registrationParticipantId: participantDetails?.registrationParticipantId
            }}
          />
          <ButtonGroup inlineFormButtons>
            {service.isFormDisabled ? (
              <Button
                label={copies.get("continue")}
                className="stylizedLargeBtn"
                onClick={() => props.onSuccessHandler?.()}
              />
            ) : (
              <Button
                className="stylizedLargeBtn"
                label={service.isApplicationFlow ? copies.get("apply") : copies.get("save")}
                type={ButtonType.SUBMIT}
                onClick={() => service.formRef.current?.submitForm()}
              />
            )}
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}
